import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgNoAccountsIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 22,
	height: 22,
	viewBox: "0 0 22 22",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("circle", {
		cx: 11,
		cy: 11,
		r: 10,
		stroke: "#999999",
		strokeWidth: 1.2
	}), /* @__PURE__ */ _jsx("path", {
		d: "M15.4463 15.4444L6.5574 6.55554",
		stroke: "#999999",
		strokeWidth: 1.2,
		strokeLinecap: "round"
	})]
});
export default SvgNoAccountsIcon;
